export default __webpack_public_path__ + "static/media/insurance-first-layer-top.1fd3ccc9.svg";